import { createHttpEndpoint } from '../utils'

import type { ApiArticlePageContent } from './models/article-page-content'
import type { BasePageContentAPI } from './models/base-page-content'

/**
 * Retrieve content for a given pageName and pageType
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/content-service-web-api/definition}
 */
export const getPageContent = createHttpEndpoint<BasePageContentAPI>({
  method: 'GET',
  operationId: 'fetchContentFromContentService',
  path: '/content/page/:pageType/:pageName',
})

/**
 * Retrieve content for a given pageName, pageCategory and pageType
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/content-service-web-api/definition}
 */
export const getPageCategoryContent = createHttpEndpoint<BasePageContentAPI>({
  method: 'GET',
  operationId: 'fetchCategoryContentFromContentService',
  path: '/content/page/:pageType/:pageName/:pageCategory',
})

/**
 * SEO Articles related
 */

export const getArticleContent = createHttpEndpoint<ApiArticlePageContent>({
  method: 'GET',
  operationId: 'getArticleContent',
  path: '/content/page/:pageType/:pageName',
})
